import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'reason-form-multiple-choice',
  template: `
    <div class="answer-wrapper">
      <div class="multiple-choices">
        <div class="custom-input -small -radio" *ngFor="let choice of question.choices; let i = index">
          <input type="radio" name="reason-form-multiple-choice" 
                 id="reason-form-multiple-choice[{{i}}]" 
                 value="{{ choice.id }}" 
                 [(ngModel)]="answer.choiceId"
                 (ngModelChange)="validationChange.emit(!!answer.choiceId.length)">
          <label for="reason-form-multiple-choice[{{i}}]">{{ choice.text }}</label>
        </div>
      </div>
    </div>
  `,
})

export class ReasonFormMultipleChoiceComponent {
  @Input() question: any;
  @Input() answer: any;
  @Output() validationChange = new EventEmitter();
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form-multiple-choice.component.ts